import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface ReserveSpecifyBranchCode {
  id: number
  reserveId: number
  branchCode: SystemCode
  revision: number
}

export function ReserveSpecifyBranchCodeFromJSON(
  json: any
): ReserveSpecifyBranchCode {
  return ReserveSpecifyBranchCodeFromJSONTyped(json)
}

export function ReserveSpecifyBranchCodeFromJSONTyped(
  json: any
): ReserveSpecifyBranchCode {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: exists(json, 'id') ? json.id : 0,
    reserveId: exists(json, 'reserve_id') ? json.reserve_id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
